export const filterPublishToolNames = [
  // '联想百应服务-订单',
  // '联想百应服务-运营商服务预约',
  // '联想百应服务-服务预约',
  // '联想百应服务-IT咨询',
  // '知识库助理-文件整理',
  // '知识库助理-文件下载',
  // '知识库助理-知识导入',
  // '联想百应服务-工单订单',
  // '高德天气查询API',
  // '论文获取',
  // '经济金融数据',
  '时间',
  '计算器',
  '语音文件',
  '企业云文档创建',
  '生成二维码',
  '文生图',
  '消息通知'
]

export const workflowFilterToolNames = [
  '时间',
  '计算器',
  '语音文件',
  '企业云文档创建',
  '生成二维码',
  '文生图',
  '消息通知'
]
